import { render, staticRenderFns } from "./ConfigOverview.vue?vue&type=template&id=5e126adb"
import script from "./ConfigOverview.vue?vue&type=script&lang=js"
export * from "./ConfigOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports